var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 7L36 4L33 7L30 4L27 7L24 4L21 7L18 4L15 7L12 4L9 7L6 4V44L9 41L12 44L15 41L18 44L21 41L24 44L27 41L30 44L33 41L36 44L39 41L42 44V4L39 7ZM38 38.18H10V9.82H38V38.18ZM12 30H36V34H12V30ZM12 22H36V26H12V22ZM12 14H36V18H12V14Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.4a7d5204365acabc0d3bf5329a6b11a1.svg";
export { ForwardRef as ReactComponent };